import * as React from 'react';

import { createApolloFetch } from 'apollo-fetch';

const queryFrontend = `
  {
    frontend(where: { url: "/en", origin: "https://www.divesoft.com" }) {
      website {
        id
        languages {
          id
          code
        }
      }
      navigations {
        name
        nodes {
          id
          parent
          page
          title
          link
        }
      } 
    }  
  }`;

const queryPagesUrls = `
  query pagesUrls($languageId: ID, $websiteId: ID) {
    pagesUrls(where: {
      language: $languageId,
      websiteId: $websiteId
    }) {
      id
      url
      page
      name
      description
    }
  }`;

interface IWebNavigationProps {
  children?: any;
}

interface IWebNavigationState {
  navData: any;
}

class WebNavigation extends React.Component<IWebNavigationProps, IWebNavigationState> {

  public constructor(props: IWebNavigationProps) {
    super(props);

    this.state = {
      navData: undefined,
    };
  }

  public componentDidMount() {
    const fetch = createApolloFetch({
      uri: 'https://www.divesoft.com/api/graphql',
    });

    // stáhnu frontend
    fetch({
      query: queryFrontend
    }).then((frontend: any) => {
      if (
        frontend.data &&
        frontend.data.frontend &&
        frontend.data.frontend.website &&
        frontend.data.frontend.navigations
      ) {
        const { website, navigations } = frontend.data.frontend;
        const language = website && website.languages && website.languages.find((l: any) => l.code === 'en');

        // stáhnu seznam stránek
        fetch({
          query: queryPagesUrls,
          variables: {
            languageId: language.id,
            websiteId: website.id,
          }
        }).then((pages: any) => {
          if (
            pages &&
            pages.data &&
            pages.data.pagesUrls
          ) {
            // sestavení požadovaného ...
            const navData = navigations.map((navi: any) => {
              // projdu odkazy v nodech
              if (navi.nodes) {
                navi.nodes = navi.nodes.map((node: any) => {
                  node.page = pages.data.pagesUrls.find((page: any) => {
                    return node.page === page.page;
                  });
                  return node;
                });
              }

              return navi;
            });

            // console.log('WebNavigation setState navData', navData);
            this.setState({
              navData,
            });
          }
        });

      }
    }).catch((err: any) => {
      console.error(err);
    });
  }

  public render() {
    if (this.props.children) {
      return React.Children.map(this.props.children, children => {
        return React.cloneElement(children, {
          navData: this.state.navData,
        });
      });
    }
    
    return null;
  }
}

export default WebNavigation;


// WEBPACK FOOTER //
// ./src/components/WebNavigations/WebNavigation.tsx